const WORDS = ["WISHLIST NOW", "イノエリート", "BECOME AN ELITE", "精鋭", "COMING SOON", "生存"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee-banner"
      className="relative bg-[#0C1326] py-5 md:py-6 overflow-hidden border-y border-[#00F2FE]/20"
    >
      <div className="marquee">
        {items.map((w, i) => (
          <span
            key={i}
            className="font-display font-black uppercase text-2xl md:text-3xl text-[#00F2FE] drop-shadow-[0_0_14px_rgba(0,242,254,0.45)] mx-6 flex items-center gap-6"
          >
            {w}
            <span className="text-[#F9D423] text-lg">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
